import config from '@config/config';

import { StatBatchDeployment } from '../const';

export const statBatchDeploymentToBaseUrl = (deployment: StatBatchDeployment) => {
  return config.byocGlobalServiceBasePath;
};

export const getDefaultStatBatchDeployment = () => StatBatchDeployment.EU_CENTRAL_DEPLOYMENT;
